import { useMemo } from "react";

const JobCardCheckpointFilter = ({
  setupData,
  selectedCheckpointId,
  setSelectedCheckpointId,
}) => {
  // Get check points list
  const activeCheckpoints = useMemo(() => {
    return setupData
      ?.filter((stage) => stage.isActive)
      ?.flatMap((stage) =>
        stage.checkpoints
          ?.filter((cp) => cp.isActive && cp.requiresInformed)
          ?.map((cp) => ({
            id: cp.id,
            name: cp.name,
          })),
      );
  }, [setupData]);

  return (
    <select
      value={selectedCheckpointId}
      onChange={(e) => setSelectedCheckpointId(e.target.value)}
      className="border border-stone-300 rounded-lg p-2 text-sm bg-white focus-input max-md:w-full"
    >
      <option value="">All Checkpoints</option>
      {activeCheckpoints.map((cp) => (
        <option key={cp.id} value={cp.id}>
          {cp.name}
        </option>
      ))}
    </select>
  );
};

export default JobCardCheckpointFilter;
